
export const CAMPAIGN_GET_SERVER_DATA = 'CAMPAIGN_GET_SERVER_DATA';
export const CAMPAIGN_GET_SERVER_DATA_SUCCESS = 'CAMPAIGN_GET_SERVER_DATA_SUCCESS';
export const CAMPAIGN_GET_SERVER_DATA_REQUEST = 'CAMPAIGN_GET_SERVER_DATA_REQUEST';


export const CAMPAIGN_UPDATE_LOCAL_STORE = 'CAMPAIGN_UPDATE_LOCAL_STORE';
export const CAMPAIGN_UPDATE_LOCAL_STORE_NEW = 'CAMPAIGN_UPDATE_LOCAL_STORE_NEW';

export const CAMPAIGN_UPDATE_SERVER_DATA = 'CAMPAIGN_UPDATE_SERVER_DATA';
export const CAMPAIGN_UPDATE_SERVER_DATA_SUCCESS = 'CAMPAIGN_UPDATE_SERVER_DATA_SUCCESS'
export const CAMPAIGN_UPDATE_SERVER_DATA_REQUEST = 'CAMPAIGN_UPDATE_SERVER_DATA_REQUEST'

export const CAMPAIGN_DELETE_SERVER_DATA = 'CAMPAIGN_DELETE_SERVER_DATA';
export const CAMPAIGN_DELETE_SERVER_DATA_SUCCESS = 'CAMPAIGN_DELETE_SERVER_DATA_SUCCESS'
export const CAMPAIGN_DELETE_SERVER_DATA_REQUEST = 'CAMPAIGN_DELETE_SERVER_DATA_REQUEST'

export const CAMPAIGN_CREATE_SERVER_DATA = 'CAMPAIGN_CREATE_SERVER_DATA';
export const CAMPAIGN_CREATE_SERVER_DATA_SUCCESS = 'CAMPAIGN_CREATE_SERVER_DATA_SUCCESS'
export const CAMPAIGN_CREATE_SERVER_DATA_REQUEST = 'CAMPAIGN_CREATE_SERVER_DATA_REQUEST'



export const CAMPAIGN_AUTH_ERROR = 'CAMPAIGN_AUTH_ERROR'


export const getServerData = (payload) => ({
    type: CAMPAIGN_GET_SERVER_DATA,
    payload
})

export const getServerDataRequest = (payload) => ({
    type: CAMPAIGN_GET_SERVER_DATA_REQUEST,
    payload
})

export const getServerDataSuccess = (payload) => ({
    type: CAMPAIGN_GET_SERVER_DATA_SUCCESS,
    payload
})


export const updateServerData = (payload) => ({
  type: CAMPAIGN_UPDATE_SERVER_DATA,
  payload
})

export const updateServerDataRequest = (payload) => ({
  type: CAMPAIGN_UPDATE_SERVER_DATA_REQUEST,
  payload
})

export const updateServerDataSuccess = (payload) => ({
  type: CAMPAIGN_UPDATE_SERVER_DATA_SUCCESS,
  payload
})

export const createServerData = (payload) => ({
  type: CAMPAIGN_CREATE_SERVER_DATA,
  payload
})

export const createServerDataRequest = (payload) => ({
  type: CAMPAIGN_CREATE_SERVER_DATA_REQUEST,
  payload
})

export const createServerDataSuccess = (payload) => ({
  type: CAMPAIGN_CREATE_SERVER_DATA_SUCCESS,
  payload
})


export const deleteServerData = (payload) => ({
  type: CAMPAIGN_DELETE_SERVER_DATA,
  payload
})

export const deleteServerDataRequest = (payload) => ({
  type: CAMPAIGN_DELETE_SERVER_DATA_REQUEST,
  payload
})

export const deleteServerDataSuccess = (payload) => ({
  type: CAMPAIGN_DELETE_SERVER_DATA_SUCCESS,
  payload
})

export const updateLocalStore = (payload) => ({
  type: CAMPAIGN_UPDATE_LOCAL_STORE,
  payload
})

export const updateLocalStoreNewCompany = (payload) => ({
  type: CAMPAIGN_UPDATE_LOCAL_STORE_NEW,
  payload
})


export const authError = (error) => ({
    type: CAMPAIGN_AUTH_ERROR,
    error
})


